export const PaySystem = Object.freeze({
	type: {
		cash: 'CASH',
		cashLess: 'CASH_LESS',
		cardTransaction: 'CARD_TRANSACTION',
		undefined: 'UNDEFINED'
	}
});